var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('Home')))]),_c('v-row',{staticClass:"mt-5 mx-0"},[_c('h1',{staticStyle:{"margin":"0 auto","font-size":"42px","color":"brown"}},[_vm._v("Welcome on Vision Optics ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }